// src/components/NewOrderNotification.tsx
import React from 'react';
import { toast } from 'react-toastify';
import { Box, Typography, Button } from '@mui/material';
import ComputerIcon from '@mui/icons-material/Computer';
import { Order } from '../api/orderApi';
import { useNavigate } from 'react-router-dom';

export const showNewOrderPopup = (order: Order) => {
  toast(
    ({ closeToast }) => <NewOrderNotification order={order} onClose={closeToast} />,
    {
      autoClose: false,
      position: 'top-right',
      closeOnClick: false,
      draggable: false,
      toastId: `new-order-${order.order_id}`,
    }
  );
};

interface Props {
  order: Order;
  onClose?: () => void;
}

const NewOrderNotification: React.FC<Props> = ({ order, onClose }) => {
  const navigate = useNavigate();

  const handleViewOrder = () => {
    navigate('/orders');
    onClose?.();
  };

  const totalAmount = Number(order.total_price) || 0;

  return (
    <Box sx={{ p: 2, maxWidth: 320 }}>
      <Box display="flex" alignItems="center" mb={1}>
        <ComputerIcon color="secondary" sx={{ mr: 1 }} />
        <Typography variant="subtitle1" fontWeight={600}>
          New Online Order #{order.order_id}
        </Typography>
      </Box>
      <Typography variant="body2" sx={{ mb: 1 }}>
        {order.customer_name || 'Customer'} placed an order of ${totalAmount.toFixed(2)}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        fullWidth
        size="small"
        onClick={handleViewOrder}
        sx={{ borderRadius: 20, mt: 1 }}
      >
        View Order
      </Button>
    </Box>
  );
};

export default NewOrderNotification;
